<template>
  <div class="ProjectStaff">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md12>
          <v-card class="mb-2">
            <v-card-title class="title">
              Personal del Proyecto: {{ project.nombre_proyecto }}
              <v-spacer/>

              <v-text-field
                v-if="dataVals !== null"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer/>

              <!-- <v-card-actions>
                <v-btn color="info" :disabled="dataVals.length === 0">
                  <download-csv
                    :data="dataVals"
                    :name="''"
                    :labels="labelsTotal"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions> -->

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="info" dark class="mb-2" v-on="on">Nuevo Usuario</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="form"
                    >
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="editedUser.rol"
                            :items="rol"
                            label="Rol de Usuario*"
                            required
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedUser.persona"
                            label="Persona*"
                            counter="40"
                            :rules="userRules"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedUser.proyecto"
                            label="Proyecto*"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedUser.grupo"
                            label="Grupo*"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedUser.superior"
                            label="Superior"
                            :rules="userRules"
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <small>* Campos obligatorios</small>
                  </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" @click="close">Cancelar</v-btn>
                    <v-btn
                      :disabled="!form"
                      color="success"
                      @click="save"
                    >Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-data-table
              dense
              :headers="headers"
              :items="dataVals"
              :search="search"
              :custom-filter="customFilter"
              no-results-text="No se encontro el término buscado"
              no-data-text="No hay datos disponibles"
              multi-sort
              class="elevation-1"
              loading="Cargando... Por favor espere."
              rows-per-page-text="Filas por página:"
            >
              <template slot="items" slot-scope="props">
                <td>{{ roldef[props.item.rol] }}</td>
                <td>{{ props.item.grupo }}</td>
                <td>{{ props.item.persona }}</td>
                <td>{{ props.item.proyecto }}</td>
                <td>{{ props.item.superior }}</td>
                <td class="justify-center layout px-0">
                  <v-icon
                    color="info"
                    @click="editUser(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    color="error"
                    @click="deleteUser(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Eliminar Usuario</span>
                </v-card-title>
                <v-card-text>
                  Seguro que quiere quitar el usuario con cedula: <br>
                  <span class="title">
                    {{ editedUser.cedula }}
                  </span> <br>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo quitar el usuario"
                  ></v-checkbox>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="error"
                    @click="byeUser"
                    :disabled="!checkbox"
                  >Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
          {{ form }}

          <pretty-json
            :data="editedUser"
          ></pretty-json>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JsonPretty from 'vue-json-pretty'
// import JsonCSV from 'vue-json-csv'

export default {
  name: `ProjectStaff`,

  components: {
    // 'download-csv': JsonCSV,
    'pretty-json': JsonPretty
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.project = this.$store.state.actualProject
    this.getProjectStaff()
  },

  data: function () {
    return {
      backConf: {
        pathList: '/core/gp/?page=',
        pathCUD: '/core/gp/', // Post sin documento demas con documento
        pathPerson: '',
        pathProject: '',
        pathOper: '',
        page: 1
      },

      project: null,

      progressSize: 70,
      progressWidth: 7,

      loading: false,
      form: false,
      checkbox: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        { text: 'Rol', value: 'rol' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Persona', value: 'persona' },
        { text: 'Proyecto', value: 'proyecto' },
        { text: 'Superior', value: 'superior' },
        { text: 'Acciones', value: '', align: 'left', sortable: false }
      ],
      dataVals: [],
      defaultUser: {
        'rol': null,
        'grupo': null,
        'persona': null,
        'proyecto': null,
        'superior': null
      },
      tableProjectStaffKey: 0,

      search: '',
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedUser: {
        'rol': null,
        'grupo': null,
        'persona': null,
        'proyecto': null,
        'superior': null
      },

      rol: [
        { text: 'Administrador', value: 'A' },
        { text: 'Coordinador - IK', value: 'CIK' },
        { text: 'Cliente', value: 'CL' },
        { text: 'Coordinador - Campo', value: 'CC' },
        { text: 'Supervisor', value: 'S' },
        { text: 'Encuestador', value: 'EC' },
        { text: 'Enumerador', value: 'EN' },
        { text: 'Auditor', value: 'AU' }
      ],

      roldef: {
        A: 'Administrador',
        CIK: 'Coordinador - IK',
        CL: 'Cliente',
        CC: 'Coordinador - Campo',
        S: 'Supervisor',
        EC: 'Encuestador',
        EN: 'Enumerador',
        AU: 'Auditor'
      },

      userRules: [
        v => !!v || 'Campo requerido',
        v => (v.length < 41) || 'Maximo 40 caracteres'
      ]
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  computed: {
    /** Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    }
  },

  methods: {
    /** Carga la información de todos los usuarios
     */
    getProjectStaff () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getProjectStaff()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))

      t.tableProjectStaffKey += 1
    },

    /** Carga los datos del usuario seleccionado y abre el dialog
     * @param  {Object} user El usuario a editar
     */
    editUser (user) {
      this.editedIndex = this.dataVals.indexOf(user)
      this.editedUser = Object.assign({}, user)
      this.dialog = true
    },

    /** Carga los datos del usuario seleccionado y abre el dialog
     * @param  {Object} user El usuario a eliminar
     */
    deleteUser (user) {
      this.editedIndex = this.dataVals.indexOf(user)
      this.editedUser = Object.assign({}, user)
      this.dialogDelete = true
    },

    /** Elimina el usaurio seleccionado, previa confirmación
     * actualiza la tabla local
     */
    byeUser () {
      let request = {
        method: 'delete',
        data: {},
        url: this.backConf.pathCUD + this.editedUser.cedula + '/'
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.close()
        })
        .catch(err => console.error(err))
    },

    /** Limpia el formulario de usuario y setea el index del elemento
     */
    close () {
      this.dialog = false
      this.dialogDelete = false
      setTimeout(() => {
        this.editedUser = Object.assign({}, this.defaultUser)
        this.editedIndex = -1
      }, 300)
    },

    /** Guarda la información del usuario,
     * sea un usuario nuevo o una actualización
     * actualiza la tabla local
     */
    save () {
      let request = {
        method: this.editedIndex > -1 ? 'put' : 'post',
        data: this.editedUser,
        url: this.editedIndex > -1 ? this.backConf.pathCUD + this.editedUser.cedula + '/' : this.backConf.pathCUD
      }
      console.log('method', request.method)
      console.log('data', JSON.stringify(request.data))
      console.log('url', request.url)

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (t.editedIndex > -1) {
            Object.assign(t.dataVals[t.editedIndex], t.editedUser)
          } else {
            t.dataVals.push(t.editedUser)
          }
          t.close()
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
